export const COACH_FIELDS = [
  { field: "Full Name", key: "fullName", input: "Text", example: "John Carter" },
  { field: "Email", key: "email", input: "Email Input", example: "john.carter@example.com" },
  { field: "Phone", key: "phoneNumber", input: "Text", example: "+1 (555) 234-5678" },
  { field: "School/College", key: "teamName", input: "Text", example: "Central Valley JC" },
  { field: "Role / Position", key: "jobTitle", input: "Text", example: "Head Coach" },
  { field: "Organization", key: "organization", input: "Text", example: "NCAA" },
  { field: "Visibility", key: "isActive", input: "Toggle", example: "Show on site" },
];
